import Box from "@mui/material/Box"
import Typography from "@mui/material/Typography"
import LoadingButton from "../Button"
import {source} from "../../constants/imageUrls"

const SessionExpired = () => {
    const handldeLogIn = () => {
        window.location.href = "/auth"
        localStorage.clear()
    }

    return (
        <Box
            marginTop={"50px"}
            display={"flex"}
            alignItems={"center"}
            justifyContent={"center"}
            flexDirection={"column"}
            rowGap={"45px"}
        >
            <img height={"208px"} width={"272px"} src={source.errorPage.SessionExpiredBg} alt="Session Expired" />
            <Typography fontWeight={"700"} variant="h5">
                Your Session Has Expired
            </Typography>
            <LoadingButton onClick={() => handldeLogIn()} variant="contained">
                Log In
            </LoadingButton>
        </Box>
    )
}
export default SessionExpired
